<small *ngIf="online; else offline" class="text-muted d-lg-none">
  <!--<span class="badge badge-dot badge-success d-inline-block mr-1"></span>-->
  Онлайн
</small>
<ng-template #offline>
  <small *ngIf="!online && last_seen?.time" class="text-muted">
    <ng-template [ngIf]="isActual" [ngIfElse]="load">
      <span>Заходил(a) {{ last_seen.time | timeago }}</span>
      <ng-container [ngSwitch]="last_seen.platform">
        <!-- # определение платформы по ее коду -->
        <ng-template [ngSwitchCase]="1">
          &nbsp;<i-feather tooltip="Через официальную мобильную версию web-сайта VK" name="smartphone"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="2">
          &nbsp;<i-feather tooltip="Через официальное приложение VK для iPhone" name="smartphone"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="3">
          &nbsp;<i-feather tooltip="Через официальное приложение VK для iPad" name="tablet"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="4">
          &nbsp;<i-feather tooltip="Через официальное приложение VK для Android" name="smartphone"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="5">
          &nbsp;<i-feather tooltip="Через официальное приложение VK для Windows Phone" name="smartphone"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="6">
          &nbsp;<i-feather tooltip="Через официальное приложение VK для Windows" name="monitor"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="7">
          &nbsp;<i-feather tooltip="Через официальную web-версию VK" name="globe"></i-feather>
        </ng-template>
      </ng-container>
    </ng-template>
    <ng-template #load>Зарузка...</ng-template>
  </small>
</ng-template>
